import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {ContactTypeService} from '../../../_services/contact-type-service';
import {ContactTypeResponse} from '../../../_models/contact-type.model';
import {Subscription} from 'rxjs';
import {
    ColumnFilter,
    DataTableColumnData, DatatableComponent,
    DataTableConfig, DataTableDataSource,
    DataTableLazyLoadDataSource,
    DataTableLazyLoadRefresher, DataTableObservableCompletionListener,
    DataTableObservableErrorListener,
    TableAction
} from '@cas-hub/acabim-common-client';

@Component({
    selector: 'acabim-admin-contact-types',
    templateUrl: './contact-type.component.html',
    styleUrls: ['./contact-type.component.scss']
})
export class ContactTypesComponent implements OnInit, OnDestroy {

    contactTypesSub: Subscription | null = null;
    currentDataSource = 0;
    addContactTypeModal = false;
    editContactTypeModal = false;
    @ViewChild('dataTable') public dataTable!: DatatableComponent;
    public dataSources: DataTableDataSource<any>[] = [];

    constructor(
        private contactTypeService: ContactTypeService
    ) {}

    ngOnInit(): void {
        this.dataSources.push(
            new ContactTypeDataSource(
                (first, length, sortOrder, sortField, filters) =>
                    this.contactTypeService.getContactTypes(),
                (tableName: string, error: Error) => {
                },
                (tableName: string) => {
                }, (action: TableAction) => {
                    if (action.id === 0) {
                    } else if (action.id === 1) {
                    }
                },
                'Active types'
            )
        );
        this.dataSources.push(
            new ContactTypeDataSource(
                (first, length, sortOrder, sortField, filters) =>
                    this.contactTypeService.getContactTypes(true),
                (tableName: string, error: Error) => {
                },
                (tableName: string) => {
                }, (action: TableAction) => {
                    if (action.id === 0) {
                    } else if (action.id === 1) {
                    }
                },
                'Inactive types'
            )
        );

    }

    ngOnDestroy(): void {
        if (this.contactTypesSub != null) {
            this.contactTypesSub.unsubscribe();
        }
    }

    // Add
    onAddContactType(): void {
        this.addContactTypeModal = true;
    }

    setAddContactTypeModal(value: boolean): void {
        this.addContactTypeModal = value;
    }

    onAddCompletion(completed: string) {
        this.addContactTypeModal = false;
        if (completed === 'added') {
            this.setAddContactTypeModal(false);
            this.dataTable?.requestImmediateDataRefresh();
        } else if (completed === 'cancelled') {
            this.setAddContactTypeModal(false);
        }
    }

    // Edit
    setEditContactTypeModal(value: boolean): void {
        this.editContactTypeModal = value;
        this.dataSources[this.currentDataSource].showDetails = value;
    }

    onEditCompletion(completed: string) {
        this.editContactTypeModal = false;
        if (completed === 'updated' || completed === 'deleted') {
            this.setEditContactTypeModal(false);
            this.dataTable?.requestImmediateDataRefresh();
        } else if (completed === 'cancelled') {
            this.setEditContactTypeModal(false);
        }
    }

    getCurrent($event: number): void {
        this.currentDataSource = $event;
    }

} // EOC

export class ContactTypeDataSource extends DataTableLazyLoadDataSource<ContactTypeResponse> {

    readonly columnData: DataTableColumnData[] =
        [
            {displayName: 'Name', objectPropertyName: 'name', colWidth: '15rem'},
            {displayName: 'Description', objectPropertyName: 'description'}
        ];

    readonly config: DataTableConfig = {
        tableHeading: '',
        isSearchEnabled: false,
        searchPlaceHolder: 'Search contact types',
        emptyMessage: '',
        globalFilterFields: [],
        hasCheckbox: false,
        hasDetailsButton: true,
        isLazyLoadingEnabled: false,
        isPaginationEnabled: false,
        hasFilters: false,
        isExportEnabled: false,
        hasActions: false
    };

    readonly columnFilters: ColumnFilter[] = [];

    readonly actions: TableAction[] = [{name: 'Archive', id: 0}, {name: 'Group', id: 1}];

    onDataExpanded(value: ContactTypeResponse): void {
    }

    constructor(readonly refresher: DataTableLazyLoadRefresher<ContactTypeResponse>,
                readonly observableErrorListener?: DataTableObservableErrorListener,
                readonly observableCompleteListener?: DataTableObservableCompletionListener,
                readonly actionListener?: (action: TableAction) => void,
                readonly title?: string
                ) {
        super(refresher, observableErrorListener, observableCompleteListener);
        if (title) {
            this.config.tableHeading = title;
        }
    }

    onAction(action: TableAction): void {
        if (this.actionListener) {
            this.actionListener(action);
        }
    }
}
